import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AdminApp from './containers/AdminApp';
import AdminProductionList from './containers/AdminProductionList';
import MovieEditor from './containers/MovieEditor';
import { requireAuthentication } from '../../containers/AuthenticatedApp';

const AdminRoutes = () => (
  <AdminApp>
    <Switch>
      <Route exact path="/admin" component={AdminProductionList} />
      <Route
        path="/admin/movies/:movieKey"
        render={(routeProps) => <MovieEditor {...routeProps} />}
      />
    </Switch>
  </AdminApp>
);

export default requireAuthentication(AdminRoutes);
